<template>
  <div class="real-weight-form">
    <weighing-steps :ingredients="ingredients" />
    <div class="d-flex align-items-start">
      <div class="mr-2 weight-field">
        <div class="input-group">
          <input
            :id="inputId"
            v-model="rawKilograms"
            type="text"
            inputmode="decimal"
            autocomplete="off"
            class="form-control weight-input"
            :placeholder="texts.REAL_WEIGHT_PLACEHOLDER"
            :aria-label="texts.REAL_WEIGHT_ARIA_LABEL"
            @keyup.enter="submit"
          />
          <div class="input-group-append">
            <span class="input-group-text">{{ texts.KILOGRAMS_SUFFIX }}</span>
          </div>
        </div>
      </div>
      <base-button
        class="cooked-weights-button cooked-weights-button--primary"
        :loading="loading"
        :disabled="!canSubmit"
        @click="submit"
      >
        {{ texts.SAVE_WEIGHT }}
      </base-button>
    </div>
    <p v-if="hasInvalidFormat" class="weight-format-error">{{ texts.INVALID_WEIGHT_FORMAT }}</p>
    <p class="weight-hint">{{ texts.WEIGHT_FORMAT_HINT }}</p>
  </div>
</template>

<script>
import { parseKilograms, kilogramsToGrams } from '@/utils/kilosFormat'
import { TEXTS, REAL_WEIGHT_INPUT_ID_PREFIX } from '../cookedWeightsConstants'
import { confirmWeight, dismissWeightConfirmation } from '../weightConfirmation'
import WeighingSteps from './WeighingSteps.vue'

export default {
  name: 'RealWeightForm',
  components: {
    WeighingSteps
  },
  props: {
    ingredients: {
      type: Array,
      default: () => []
    },
    groupId: {
      type: [Number, String],
      required: true
    },
    minimumGrams: {
      type: Number,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      rawKilograms: '',
      isClosed: false
    }
  },
  computed: {
    texts () {
      return TEXTS
    },
    inputId () {
      return `${REAL_WEIGHT_INPUT_ID_PREFIX}-${this.groupId}`
    },
    parsedKilograms () {
      return parseKilograms(this.rawKilograms)
    },
    parsedGrams () {
      return this.parsedKilograms === null ? null : kilogramsToGrams(this.parsedKilograms)
    },
    hasInvalidFormat () {
      return this.rawKilograms.trim() !== '' && this.parsedKilograms === null
    },
    canSubmit () {
      return this.parsedGrams !== null && this.parsedGrams > 0
    }
  },
  beforeDestroy () {
    this.isClosed = true
    dismissWeightConfirmation()
  },
  methods: {
    submit () {
      if (!this.canSubmit || this.loading) {
        return
      }
      confirmWeight(this.parsedGrams, this.minimumGrams)
        .then((confirmed) => confirmed && !this.isClosed && this.emitWeight())
    },
    emitWeight () {
      this.$emit('submit-real-weight', this.parsedGrams)
    }
  }
}
</script>

<style scoped>
.weight-field {
  flex: 1 1 auto;
  max-width: 280px;
}

.weight-hint,
.weight-format-error {
  margin: 8px 0 0;
  font-size: var(--font-small);
  color: var(--text-muted);
}

.weight-format-error {
  font-weight: 600;
  color: var(--danger-text);
}


.weight-input {
  min-height: var(--input-height);
  font-size: var(--font-large);
  font-weight: 600;
}

.real-weight-form .input-group-text,
.real-weight-form .cooked-weights-button {
  min-height: var(--input-height);
}
</style>

<style>
.weight-confirmation-value {
  font-size: 2.5rem;
  font-weight: bold;
}

.weight-confirmation-warning {
  color: #b45309;
  font-weight: bold;
}
</style>
